import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { NewAcocuntSetup } from "../../components/NewAcocuntSetup";

export const NewAcocuntSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="New Account Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "New Account Setup", navigateTo: "#" }
      ]}
      mainContents={<NewAcocuntSetup />}
    />
  );
};
